import { useUserStore } from "@/stores/userStore"
import { Navigate } from "react-router-dom"
import RouteLoadingBar from "@/components/RouteLoadingBar"
import { lazy, Suspense } from "react"
import { Layout, Skeleton } from "antd"
import Content from "@/layouts/Content/index"

const Header = lazy(() => import("@/layouts/Header"))
const LeftMenu = lazy(() => import("@/layouts/LeftMenu"))

/**
 * Authenticated Layout Component. Layout khi đã login.
 */
export function AuthenticatedLayout() {
  const { isLogin } = useUserStore.getState()

  if (!isLogin) {
    const currentPath = window.location.pathname + window.location.search
    return <Navigate to={`/login?redirect=${encodeURIComponent(currentPath)}`} replace />
  }

  return (
    <>
      <RouteLoadingBar />
      <Layout className="h-full">
        <Suspense fallback={<Skeleton active />}>
          <LeftMenu />
        </Suspense>
        <Layout>
          <Suspense fallback={<Skeleton active />}>
            <Header />
          </Suspense>

          <Content />

          <Layout.Footer style={{ textAlign: "center", backgroundColor: "var(--ant-color-bg-base)" }}>
            jupi.vn ©2026. Công ty Cổ phần công nghệ giáo dục Thành Phát
          </Layout.Footer>
        </Layout>
      </Layout>
    </>
  )
}
